import { ApiService } from '@app/gateway/services/api.service'
import { Component, OnInit, DoCheck } from '@angular/core'
import { StateService } from '@app/services/state/state.service'
import { Router } from '@angular/router'
import { UserProfileComponent } from '../user-profile.component'
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '@app/services/token/token.service'
//import Vs from '@app/services/validators/validators.service'
declare let gtag: Function;

@Component({
    selector: 'nh-autoRenewal',
    templateUrl: './auto-renewal.component.html',
    styleUrls: ['./auto-renewal.component.scss'],
    standalone: false
})
export class AutoRenewalComponent implements OnInit, DoCheck {
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  defaultLanguage;
  translatedLang;
  updateSuccess = false;
  enableAVSUpdate = false;
  enableUpdate = false;
  caseSelected = false;
  caseNumbers = [];
  caseList = []
  items = []
  showRenewSW;
  showAvsSW;
  enableRenewEligibility = false;
  enableSelect = false;
  autoRenewalForm = new UntypedFormGroup({
    caseNumber: new UntypedFormControl(''),
    renewCoverageYesCheck: new UntypedFormControl(''),
    renewCoverageNoCheck: new UntypedFormControl(''),
    avsYesCheck: new UntypedFormControl(''),
    avsNoCheck: new UntypedFormControl(''),
    yearsRenewedCD: new UntypedFormControl(''),
  });
  individualId = sessionStorage.getItem('individualId');

  constructor(
    public apiService: ApiService,
    public stateService: StateService,
    public router: Router,
    public translateService: TranslateService,
    public userProfileComponent: UserProfileComponent,
    private titleService: Title,
    private token: TokenService
  ) {
    this.titleService.setTitle('Auto Renewal');
  }


  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }

  ngOnInit(): void {
    const url = `indi/autoRenewal/${this.individualId}`
    this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCATR', 'sessionId' : this.token.getSessionId()})}).subscribe(response => {
      if (response && response['autoRenewalUseAvsCaseDetails'] && response['autoRenewalUseAvsCaseDetails']['length']) {
        this.caseList = response['autoRenewalUseAvsCaseDetails']

        if (this.caseList.length === 1) {
          this.autoRenewalForm.controls.caseNumber.patchValue(this.caseList[0].caseNum)
          this.caseSelected = true;
          this.showRenewSW = this.caseList[0].showRenewSW;
          this.showAvsSW = this.caseList[0].showAvsSW;          
        } else {
          this.caseList.forEach(element => {
            this.caseNumbers.push(element.caseNum)
          })
        }
      } else {
        this.router.navigateByUrl('/user-profile/benefit-dashboard')
      }
      this.defaultLanguage = this.translateService.getDefaultLang();
      this.translatedLang = this.defaultLanguage;
      this.languageCheck(this.translatedLang)
    })
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.languageCheck(this.translatedLang)
    });
  }

  languageCheck(lang) {
    const url = 'publ/reference-tables?tables=MPFINISH';
    this.apiService.get(url, null , {headers: new HttpHeaders({'pageId': 'TCATR', 'sessionId' : this.token.getSessionId()})}).subscribe(resp => {
      this.items = []
      if (lang === 'en') {
        if(resp){
          resp['referenceGroup'][0].referenceData.forEach(englishValue => {
            this.items.push({ "code": englishValue.code, "value": englishValue.value })
          });
        }
      } else {
        if(resp){
        resp['referenceGroup'][0]?.referenceData.forEach(spanishValue => {
          this.items.push({ "code": spanishValue.code, "value": spanishValue.spValue })
        });
      }
      }
      if (this.autoRenewalForm?.controls?.yearsRenewedCD?.value) {
        this.items.forEach(item => {
          if (item.code === this.autoRenewalForm?.controls?.yearsRenewedCD.value.code) {
            this.autoRenewalForm.controls.yearsRenewedCD.value.value = item.value
          }
        })
      }
    });
  }

  onCaseSelect() {
    this.showAvsSW = '';
    this.showRenewSW = '';
    if (this.autoRenewalForm?.controls?.caseNumber?.value) {
      this.enableSelect = true;
      this.caseSelected = false;
      this.enableUpdate = false;
      this.enableRenewEligibility = false;
    } else {
      this.enableSelect = false;
      this.caseSelected = false;
      this.enableUpdate = false;
      this.enableRenewEligibility = false;
      this.showAvsSW = '';
      this.showRenewSW = '';
    }
    let obj;
    this.caseList.forEach((element, idx) => {
      if (element.caseNum === this.autoRenewalForm?.controls?.caseNumber?.value) {
        obj = this.caseList[idx];
      }
    })
    if(obj)
    {
      this.showRenewSW = obj.showRenewSW;
      this.showAvsSW = obj.showAvsSW;
    }
    if (obj?.updated === true) {
      this.updateSuccess = true;
      this.enableUpdate = false;
      if (obj.permissionToRenewSW === "Y") {
        this.autoRenewalForm?.controls?.renewCoverageYesCheck.patchValue(true);
        this.autoRenewalForm?.controls?.renewCoverageYesCheck.updateValueAndValidity();
      } else {
        this.autoRenewalForm?.controls?.renewCoverageNoCheck.patchValue(false);
        this.autoRenewalForm?.controls?.renewCoverageNoCheck.updateValueAndValidity();
        this.enableRenewEligibility = false
      }
      if (obj.permissionToUseAvsSW === "Y") {        
        this.enableAVSUpdate = true; 
        this.autoRenewalForm?.controls?.avsYesCheck.patchValue(true);
        this.autoRenewalForm?.controls?.avsYesCheck.updateValueAndValidity();
      } else {
        this.enableAVSUpdate = false;
        this.autoRenewalForm?.controls?.avsNoCheck.patchValue(false);
        this.autoRenewalForm?.controls?.avsNoCheck.updateValueAndValidity();
      }
      this.items.forEach(item => {
        if (Number(item.code) === obj.yearsRenewedCD) {
          this.autoRenewalForm.controls.yearsRenewedCD.patchValue(item);
          this.autoRenewalForm?.controls?.yearsRenewedCD.updateValueAndValidity();
        }
      })
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsYesCheck.disable();
      this.autoRenewalForm?.controls?.avsYesCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsNoCheck.disable();
      this.autoRenewalForm?.controls?.avsNoCheck.updateValueAndValidity();      
      this.autoRenewalForm?.controls?.yearsRenewedCD.disable();
      this.autoRenewalForm?.controls?.yearsRenewedCD.updateValueAndValidity();
    } else {
      this.updateSuccess = false;
      this.enableRenewEligibility = false;
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.reset();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.enable();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.reset();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.enable();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsYesCheck.reset();
      this.autoRenewalForm?.controls?.avsYesCheck.enable();
      this.autoRenewalForm?.controls?.avsYesCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsNoCheck.reset();
      this.autoRenewalForm?.controls?.avsNoCheck.enable();
      this.autoRenewalForm?.controls?.avsNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.yearsRenewedCD.reset();
      this.autoRenewalForm?.controls?.yearsRenewedCD.enable();
      this.autoRenewalForm?.controls?.yearsRenewedCD.updateValueAndValidity();
    }

  }

  onSelectedCase() {
    this.caseSelected = true;
    this.enableSelect = false;
    if (this.autoRenewalForm?.controls?.renewCoverageYesCheck?.value === true) {
      this.enableRenewEligibility = true;
      this.enableRenewEligibility = true;
    }
  }

  exitAutoRenewal() {
    this.router.navigateByUrl('user-profile/benefit-dashboard');
  }

  isRenewChecked(event, otherField) {
    this.updateSuccess = false;
    
    if (event.type === 'keydown') {
      event.target.checked = !event.target.checked;
    }
    
    otherField.checked = false;
    const targetValue = event.target.value
    const isChecked = event.target.checked;
    
    if (targetValue === 'Yes') {
      this.autoRenewalForm.controls.renewCoverageYesCheck.patchValue(isChecked);
      this.autoRenewalForm.controls.renewCoverageNoCheck.patchValue(false);
    } else if (targetValue === 'No') {
      this.autoRenewalForm.controls.renewCoverageNoCheck.patchValue(isChecked);
      this.autoRenewalForm.controls.renewCoverageYesCheck.patchValue(false);
    }
    
    if (targetValue === 'Yes' && isChecked) {
      this.enableRenewEligibility = true;
      this.enableUpdate = false;
    } else if (targetValue === 'No' && isChecked) {
      this.enableRenewEligibility = false;
      this.enableUpdate = true;
      this.autoRenewalForm.controls.yearsRenewedCD.reset()
    } else {
      this.enableRenewEligibility = false;
      this.enableUpdate = false;
      this.autoRenewalForm.controls.yearsRenewedCD.reset()
    }

    if(this.showAvsSW !== 'Y')
    {
      this.autoRenewalForm?.controls?.avsNoCheck.disable();
      this.autoRenewalForm?.controls?.avsNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsYesCheck.disable();
      this.autoRenewalForm?.controls?.avsYesCheck.updateValueAndValidity();
      this.autoRenewalForm.controls.avsYesCheck.reset();
      this.autoRenewalForm.controls.avsNoCheck.reset();
      this.enableAVSUpdate = true;
    }

  }
  
  isAvsRenewChecked(event, otherField) {
    if (event.type === 'keydown') {
      event.target.checked = !event.target.checked;
    }
    
    otherField.checked = false;
    const targetValue = event.target.value
    const isChecked = event.target.checked;
    
    if (targetValue === 'Yes') {
      this.autoRenewalForm.controls.avsYesCheck.patchValue(isChecked);
      this.autoRenewalForm.controls.avsNoCheck.patchValue(false);
    } else if (targetValue === 'No') {
      this.autoRenewalForm.controls.avsNoCheck.patchValue(isChecked);
      this.autoRenewalForm.controls.avsYesCheck.patchValue(false);
    }
    
    if (targetValue === 'Yes' && isChecked) {
      this.enableAVSUpdate = true;
    } else if (targetValue === 'No' && isChecked) {
      this.enableAVSUpdate = true;
    }
    else{
      this.enableAVSUpdate = false;
    }
    if(this.showRenewSW !== 'Y')
    {
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.updateValueAndValidity();
      this.autoRenewalForm.controls.yearsRenewedCD.reset();
      this.enableUpdate = true;
    }
  }

  renewEligbilitySelect() {
    if (this.autoRenewalForm?.controls?.yearsRenewedCD?.value) {
      this.enableUpdate = true;
    } else {
      this.enableUpdate = false;
    }
  }

  gTagonSubmit(label:any, value:any) {
    gtag('event', 'permission_to_auto_renewal', {
      'event_category': 'User submitted on permission to auto renewal form',
      'event_label': label,
      'value': value
    })
  }
  updateAutoRenewal() {
    let selectedCase = {}
    if (this.autoRenewalForm?.controls?.renewCoverageNoCheck?.value === true) {
      this.updateSuccess = true;
      this.caseList.forEach((element, idx) => {
        if (element.caseNum === this.autoRenewalForm?.controls?.caseNumber?.value) {
          element.updated = true;
          element.permissionToRenewSW = "N",
            element.yearsRenewedCD = 0;
            selectedCase = this.caseList[idx]
            this.gTagonSubmit('Auto Renewal - No Selected', 'No');
        }
      })
    } else if (this.autoRenewalForm?.controls?.renewCoverageYesCheck?.value === true) {
      this.caseList.forEach((element, idx) => {
        if (element.caseNum === this.autoRenewalForm?.controls?.caseNumber?.value) {
          element.updated = true;
          element.permissionToRenewSW = "Y",
            element.yearsRenewedCD = Number(this.autoRenewalForm?.controls?.yearsRenewedCD?.value?.code)
            selectedCase = this.caseList[idx]
            this.gTagonSubmit('Auto Renewal - Yes Selected', 'Yes');
        }
      })
    }

    if (this.autoRenewalForm?.controls?.avsNoCheck?.value === true) {
      this.enableAVSUpdate = true;
      this.updateSuccess = true;
      this.caseList.forEach((element, idx) => {
        if (element.caseNum === this.autoRenewalForm?.controls?.caseNumber?.value) {
          element.updated = true;
          element.permissionToUseAvsSW = "N",
            selectedCase = this.caseList[idx]
            this.gTagonSubmit('AVS - No Selected', 'No');
        }
      })
    } else if (this.autoRenewalForm?.controls?.avsYesCheck?.value === true) {
      this.enableAVSUpdate = true;
      this.caseList.forEach((element, idx) => {
        if (element.caseNum === this.autoRenewalForm?.controls?.caseNumber?.value) {
          element.updated = true;
          element.permissionToUseAvsSW = "Y";
            selectedCase = this.caseList[idx]
            this.gTagonSubmit('AVS - Yes Selected', 'Yes');
        }
      })
    }
    const payLoad = selectedCase;
    const url = `indi/autoRenewal/${this.individualId}`;
      const contentHeader = new HttpHeaders({ "Content-Type": "application/json", "pageId": "TCATR", 'sessionId' : this.token.getSessionId()});
      this.apiService.post(url, payLoad, { observe: 'response', headers: contentHeader}).subscribe(res => {
      this.updateSuccess = res['status'] === 200 ? true : false;
      this.enableAVSUpdate = res['status'] === 200 ? true : false;
      this.enableUpdate = res['status'] === 200 ? false : true;
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.disable();
      this.autoRenewalForm?.controls?.renewCoverageYesCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.yearsRenewedCD.disable();
      this.autoRenewalForm?.controls?.yearsRenewedCD.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsNoCheck.disable();
      this.autoRenewalForm?.controls?.avsNoCheck.updateValueAndValidity();
      this.autoRenewalForm?.controls?.avsYesCheck.disable();
      this.autoRenewalForm?.controls?.avsYesCheck.updateValueAndValidity();
    });
  }
}